<template>
  <v-card-title class="d-flex flex-wrap align-center">
    <span>{{ title }}</span>

    <template v-if="grouped">
      <span
        class="text-xs font-weight-semibold ml-3"
        :class="customized ? 'check-in-state--custom' : 'check-in-state--inherit'"
      >
        {{ customized ? 'この店舗だけの設定' : 'グループの設定を使っています' }}
      </span>

      <v-spacer />

      <v-btn
        v-if="customized"
        small
        text
        class="check-in-state--danger"
        :ripple="false"
        :disabled="disabled"
        @click="$emit('inherit')"
      >
        グループの設定に戻す
      </v-btn>

      <v-btn
        v-else
        small
        outlined
        color="primary"
        :ripple="false"
        :disabled="disabled"
        @click="$emit('customize')"
      >
        この店舗だけ個別に設定する
      </v-btn>
    </template>
  </v-card-title>
</template>

<script>
// 「グループの設定を使っている / この店舗だけの設定」の表示と切り替え
export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    // グループに入っている店舗か。入っていなければ継承の表示を出さない
    grouped: {
      type: Boolean,
      default: false,
    },
    customized: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
/* Vuetify の color pack は無効のため、色は独自クラスで指定する */
.check-in-state--custom {
  color: #6b35d9;
}
.check-in-state--inherit {
  color: rgba(58, 53, 65, 0.42);
}
.check-in-state--danger {
  color: #d92d20 !important;
}
</style>
